var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFifth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 42.43 42.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #305549;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-1",
    cx: 21.21,
    cy: 21.21,
    r: 21.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.85,15.92h-8.02v3.55c.34-.38,.82-.69,1.44-.93,.62-.24,1.29-.36,2.01-.36,1.29,0,2.35,.29,3.2,.87,.85,.58,1.47,1.34,1.86,2.26,.39,.93,.59,1.93,.59,3.01,0,2-.56,3.6-1.7,4.77-1.13,1.17-2.73,1.76-4.78,1.76-1.37,0-2.56-.24-3.57-.71-1.01-.47-1.79-1.13-2.34-1.97-.55-.84-.85-1.81-.9-2.91h4.29c.1,.53,.35,.97,.75,1.32,.39,.35,.93,.53,1.62,.53,.81,0,1.41-.26,1.8-.77,.39-.51,.59-1.2,.59-2.06s-.21-1.48-.62-1.93c-.41-.45-1.01-.67-1.8-.67-.58,0-1.06,.14-1.44,.42-.38,.28-.63,.66-.75,1.12h-4.24V12.06h12.01v3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.97,18.72h-5.8c.04,.52,.21,.92,.5,1.19,.29,.28,.66,.41,1.09,.41,.64,0,1.08-.27,1.33-.81h2.73c-.14,.55-.39,1.04-.76,1.48-.37,.44-.82,.79-1.37,1.04-.55,.25-1.17,.38-1.85,.38-.82,0-1.55-.18-2.19-.53-.64-.35-1.14-.85-1.5-1.5s-.54-1.41-.54-2.28,.18-1.63,.53-2.28c.36-.65,.85-1.15,1.49-1.5,.64-.35,1.38-.53,2.21-.53s1.53,.17,2.16,.51,1.12,.82,1.48,1.46c.35,.63,.53,1.36,.53,2.2,0,.24-.01,.49-.04,.75Zm-2.58-1.42c0-.44-.15-.79-.45-1.05-.3-.26-.68-.39-1.12-.39s-.79,.12-1.09,.38-.48,.6-.55,1.06h3.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifth);
export default __webpack_public_path__ + "static/media/fifth.6f35989db0253577487808457bd8cffb.svg";
export { ForwardRef as ReactComponent };